export default {
  "content": "<path d=\"M7 10l-.707.707a1 1 0 001.414 0zm4-4l.707.707a1 1 0 00-1.41-1.418zM5.707 7.293a1 1 0 00-1.414 1.414zm2.013 3.401c.491-.51 1.483-1.502 2.36-2.374a719.42 719.42 0 011.492-1.48l.097-.095.025-.025.007-.006.001-.002L11 6c-.702-.712-.703-.711-.703-.711l-.002.002a.407.407 0 00-.032.031l-.097.096-.354.35A724.7 724.7 0 008.67 6.903c-.873.869-1.881 1.876-2.39 2.404zm2.573-5.401l-4 4 1.414 1.414 4-4zm-2.586 4l-2-2-1.414 1.414 2 2zM14 8a6 6 0 01-6 6v2a8 8 0 008-8zm-6 6a6 6 0 01-6-6H0a8 8 0 008 8zM2 8a6 6 0 016-6V0a8 8 0 00-8 8zm6-6a6 6 0 016 6h2a8 8 0 00-8-8z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};